import {
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  inject,
  WritableSignal,
  signal,
  Signal,
  computed,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { GoTop } from '@app/src/app/components/go-top/go-top';
import { FrontMenu } from '@app/src/app/components/front-menu/front-menu';
import { FrontFooter } from '@app/src/app/components/front-footer/front-footer';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { SolutionCategoryModel } from '@app/src/app/modules/solution/classes/category/model/solution.category.model';
import { buildPayload } from '@ckmk/angular';
import { ServiceCategoryService } from '@app/src/app/modules/service/service/service.category.service';
import { SolutionCategoryService } from '@app/src/app/modules/solution/service/solution.category.service';

@Component({
  selector: 'front',
  imports: [RouterOutlet, GoTop, FrontMenu, FrontFooter],
  templateUrl: './front.html',
  styleUrl: './front.scss',
  encapsulation: ViewEncapsulation.None,
})
export class Front implements OnInit, OnChanges, OnDestroy {
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly router = inject(Router);

  protected readonly serviceCategoryService = inject(ServiceCategoryService);

  protected readonly solutionCategoryService = inject(SolutionCategoryService);

  protected readonly fetched: WritableSignal<any> = signal<any>({
    serviceCategories: false,
    solutionCategories: false,
  });

  protected readonly serviceCategories: WritableSignal<ServiceCategoryModel[]> = signal<
    ServiceCategoryModel[]
  >([]);

  protected readonly solutionCategories: WritableSignal<SolutionCategoryModel[]> = signal<
    SolutionCategoryModel[]
  >([]);

  protected readonly isReady: Signal<boolean> = computed<boolean>(() => {
    const fetched = this.fetched();

    return !!fetched.serviceCategories && !!fetched.solutionCategories;
  });

  public constructor() {}

  public ngOnInit() {
    this.serviceCategoryService.categories.onQuery((res, loading) => {
      if (!loading && res) {
        this.serviceCategories.set(res);

        this.fetched.update((obj) => ({ ...obj, serviceCategories: true }));
      }
    });

    this.solutionCategoryService.categories.onQuery((res, loading) => {
      if (!loading && res) {
        this.solutionCategories.set(res);

        this.fetched.update((obj) => ({ ...obj, solutionCategories: true }));
      }
    });

    this.serviceCategoryService.categories.watchQuery(
      buildPayload()
        .into('payload', (builder) => builder.paginate(1, 4).set('includeCover', true))
        .build(),
    );

    this.solutionCategoryService.categories.watchQuery(
      buildPayload()
        .into('payload', (builder) => builder.paginate(1, 4).set('includeCover', true))
        .build(),
    );
  }

  public ngOnChanges() {}

  public ngOnDestroy() {
    this.serviceCategoryService.categories.unsubscribe(true);

    this.solutionCategoryService.categories.unsubscribe(true);
  }
}
